import { type PropsWithChildren } from 'react'
import { useTheme } from '@dhl-ui/theme'
import { Box } from '../Box'

export type IconSeverityProps = PropsWithChildren<{
  severity?: 'success' | 'info' | 'warning' | 'error'

  isBlock?: boolean
}>

/**
 * We can show an Icon with a specific severity inside a ListItem or Card for example
 */
export const IconSeverity = ({ children, severity, isBlock }: IconSeverityProps) => {
  const { palette } = useTheme()

  const color = !severity ? 'inherit' : palette[severity].main
  const backgroundColor = !severity ? 'grey.200' : palette[severity].light

  return (
    <Box
      sx={{
        display: 'inline-block',
        ...(isBlock ? { p: 1, borderRadius: 1, backgroundColor, lineHeight: 0 } : {}),
        color,
      }}
    >
      {children}
    </Box>
  )
}
